/**
 * App routes whose page lives on lukaaji.com (/terms, /privacy, /about, /contact, /faq, /help):
 * they hand over to the site page in the app language, with a link in case the redirect is blocked.
 */
import { useEffect } from 'react';
import { useLanguage } from '@/store';
import { getAppPageTranslation } from '@/utils';
import { replaceLocation, sitePageUrl, type SitePage } from '@/utils/legal';
import type { AppPageTranslationKey } from '@/utils/translations';

interface SiteRedirectProps {
  /** The site page to open. */
  page: SitePage;
  /** Names the fallback link in the app language. */
  titleKey: AppPageTranslationKey;
}

export function SiteRedirect({ page, titleKey }: SiteRedirectProps) {
  const language = useLanguage();
  const url = sitePageUrl(page, language);
  const title = getAppPageTranslation(titleKey, language);

  useEffect(() => {
    replaceLocation(url);
  }, [url]);

  return (
    <div className="container py-16 text-center">
      <a
        href={url}
        className="inline-flex min-h-11 items-center text-lg font-semibold underline underline-offset-4 hover:text-primary"
      >
        {title}
      </a>
    </div>
  );
}
